import 'imagesloaded';
import 'jquery-match-height';
import 'slick-carousel';

const $detailtabs = $('.product-detail-tabs');

if ($detailtabs.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    const $tabbedArea = $('.js-tabbed-area');
    const $tabs = $tabbedArea.find('.tabbed-area__tab');
    const $tabContents = $tabbedArea.find('.tabbed-area__content');

    $tabs.click(function click(e) {
      e.preventDefault();

      const target = $(this).data('target');
      const $tab = $tabs.filter((i, item) => $(item).data('target') === target);

      $tabs.removeClass('tabbed-area__tab--active');
      $tabContents.removeClass('tabbed-area__content--active');

      $tab.addClass('tabbed-area__tab--active');

      $tabContents
        .filter((i, item) => $(item).data('tabid') === target)
        .addClass('tabbed-area__content--active');

      const offset = $('header').height();
      $('html, body').stop().animate({
        scrollTop: $('.js-tabbed-area').offset().top - offset,
      }, 900, 'swing');
    });

    if (window.matchMedia('(max-width: 991px)').matches === false) {
      $('.tabbed-area__tab').first().addClass('tabbed-area__tab--active');
      $('.tabbed-area__content').first().addClass('tabbed-area__content--active');
    }
  };

  setTimeout(() => {
    self.initialise();
  }, 3000);
}
